export default "__VITE_ASSET__BgQ43Qk5__"